import { MarketingMenu } from '../marketing-menu';
import { exists } from '../../../functions/exists';
import type { FontStyleSheet } from '../font-style-sheets';

export class MarketingUrlPlaylistMenu extends MarketingMenu {
  public linkedURL: string;

  override isEmpty(): boolean {
    return !this.linkedURL;
  }

  hasURL(): boolean {
    return exists(this.linkedURL);
  }

  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/vgu3cok.css';
  }
}
